<div class="dots-loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>
<div *ngIf="isCaptionAvailable" class="dots-loader-content">{{caption}}</div>
